import actions from './constants';

export const toggleDatasetSubscribeSuccess = (code, subscriptions) => ({
  code,
  subscriptions,
  type: actions.TOGGLE_DATASET_SUBSCRIBE_SUCCESS,
});

export const toggleDatasetSubscribeError = (code, error) => ({
  code,
  error,
  type: actions.TOGGLE_DATASET_SUBSCRIBE_ERROR,
});
